import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

const authorizationResponseType = 'code';

export const ImperiaConfig: AuthConfig = {
  issuer: environment.IMPERIA_ISSUER,
  redirectUri: environment.IMPERIA_AD_REDIRECT_URI,
  clientId: environment.IMPERIA_AD_CLIENT_ID,
  responseType: authorizationResponseType,
  scope: environment.IMPERIA_AD_SCOPES,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: true,
  showDebugInformation: !environment.PRODUCTION, 
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  useSilentRefresh: true,
  timeoutFactor: 0.5,
  silentRefreshTimeout: 10000,
  sessionChecksEnabled: true,
};

export const B2cConfig: AuthConfig = {
  issuer: environment.B2C_ISSUER,
  redirectUri: environment.B2C_REDIRECT_URI,
  clientId: environment.B2C_CLIENT_ID,
  responseType: authorizationResponseType,
  scope: environment.B2C_SCOPES,
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: !environment.PRODUCTION, 
  skipIssuerCheck: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  useSilentRefresh: true,
  timeoutFactor: 0.5,
  silentRefreshTimeout: 10000,
  sessionChecksEnabled: true,
};
